import React from 'react';

const IdIndex = props => {
  let {index} = props;

  let els = [];

  index.forEach((el, index) => {
    if (index > 0) {
      els.push(<i key={`split-${index}`}>&ensp;|&ensp;</i>);
    }
    els.push(<a key={el.id} href={`#${el.id}`}>{el.label}</a>);
  });

  return <p>{els}</p>;
};

IdIndex.propTypes = {
  index: React.PropTypes.array.isRequired
};

export default IdIndex;



/** WEBPACK FOOTER **
 ** ./src/modules/ui/components/IdIndex.js
 **/